module.exports = __webpack_public_path__ + "img/carrots.7cbc87b2.gif";